import type {
  VehicleDetailNode,
  VehicleNote,
  VehicleNotesQuery,
  VehicleNotesQueryVariables,
} from '@/modules/vehicles/types.graphql'
import { CreateVehicleNote } from './CreateVehicleNote'
import { useQuery } from '@apollo/client'
import { VEHICLE_NOTES_QUERY } from '@/modules/vehicles/queries'
import { useMemo } from 'react'
import { VehicleNoteInfo } from './VehicleNoteInfo'
import styled from 'styled-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { H2 } from '@/components'

interface Props {
  vehicle: VehicleDetailNode
}

const NotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const VehicleNotes: React.FC<Props> = ({ vehicle }) => {
  const translations = useTranslate({
    vehicleNotes: 'vehicles.vehicle-notes',
  })
  const { data } = useQuery<VehicleNotesQuery, VehicleNotesQueryVariables>(
    VEHICLE_NOTES_QUERY,
    {
      variables: {
        vehicle: vehicle.id,
      },
    }
  )

  const notes = useMemo(() => {
    return data?.allVehicleNotes?.edges?.map(edge => edge?.node) || []
  }, [data])

  return (
    <>
      <H2>{translations.vehicleNotes}</H2>
      <NotesWrapper>
        {notes.map((note: VehicleNote) => (
          <VehicleNoteInfo key={note.id} note={note} />
        ))}
        <CreateVehicleNote vehicle={vehicle} />
      </NotesWrapper>
    </>
  )
}
